import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfoResponse } from 'redux/Api/profileApi/type';

const initialState: UserInfoResponse = {
  id: null,
  avatar: '',
  balance: 0,
  to_be_paid: 0,
  commission_min_amount: 0,
  commission_percent: 0,
  email: '',
  fio: '',
  hold: 0,
  is_2fa_enabled: false,
  is_contract_signed: false,
  name: '',
  phone: '',
  roles: [],
  order_limits: {
    min: 0,
    max: 0,
  },
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfoResponse>) => {
      return action.payload;
    },
    clearUserInfo: () => initialState,
  },
});

export const { setUserInfo, clearUserInfo } = userInfoSlice.actions;
export default userInfoSlice.reducer;
